import { useEffect, useRef, useState } from 'react';
import { useSkin, type SkinId } from '@/store/SkinContext';
import { Icon, type IconName } from '@/components/Icon';

const SKINS: { id: SkinId; label: string; icon: IconName; hint: string }[] = [
  { id: 'editorial', label: 'Editorial', icon: 'newspaper-variant-outline', hint: 'Programa oficial · Fraunces' },
  { id: 'retro', label: 'Retro', icon: 'medal-outline', hint: 'Moscú 80 · pictogramas' },
  { id: 'lane', label: 'Lane', icon: 'leaf-circle-outline', hint: 'Lanedata · mint & cream' },
];

/** Selector de skin con el mismo patrón que la web mundoatletismo: botón
 *  "Estilo · X" + panel con 3 tarjetas (icono + label + hint). */
export function SkinMenu() {
  const { skin, setSkin } = useSkin();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const current = SKINS.find((s) => s.id === skin) ?? SKINS[0];

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="ld-menu" ref={wrapRef}>
      <button
        type="button"
        className={`ld-icon-btn${open ? ' active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Estilo: ${current.label}`}
        title={`Estilo · ${current.label}`}
      >
        <Icon name={current.icon} size={20} />
      </button>
      {open ? (
        <div className="ld-menu__panel" role="menu">
          {SKINS.map((s) => (
            <button
              key={s.id}
              type="button"
              role="menuitemradio"
              aria-checked={skin === s.id}
              className={`ld-skincard${skin === s.id ? ' active' : ''}`}
              onClick={() => {
                setSkin(s.id);
                setOpen(false);
              }}
            >
              <Icon name={s.icon} size={22} />
              <span className="ld-skincard__body">
                <span className="ld-skincard__label">{s.label}</span>
                <span className="ld-skincard__hint">{s.hint}</span>
              </span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
